export default __webpack_public_path__ + "static/media/rabi.b04f943c.png";